/**
 * Partner Programme application (/landing/partner-programme). Rendered by the
 * schema-driven <LeadForm>; see src/forms/definitions/partnerApplication.jsx.
 */
import LeadForm from "@/forms/engine/LeadForm";
import partnerApplication from "@/forms/definitions/partnerApplication";

export default function PartnerApplicationForm({ context } = {}) {
  return <LeadForm schema={partnerApplication} context={context} />;
}
